export function atob(string) {
  return Buffer.from(string).toString('base64');
}
export function btoa(base64) {
  return Buffer.from(base64, 'base64').toString('ascii');
}
//# sourceMappingURL=btoa.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/text-encoding/btoa.node.js
// module id = 763
// module chunks = 0